import AssetManager from "../AssetManager";

const CustomSelectIcon = ({ handleOpen }: CustomSelectIconProps) => {
  return (
    <div
      className="custom-select-icon"
      onClick={() => {
        handleOpen();
      }}
    >
      <img src={AssetManager.getAsset("/icon_select.svg")} className="me-3" />
    </div>
  );
};

export default CustomSelectIcon;

export interface CustomSelectIconProps {
  handleOpen: () => void;
}
